import z from 'zod'

import { ENDPOINT } from '@/config/endpoint'
import { apiFactory, apiOk } from '@/libs/api'
import { zh } from '@/libs/utils/zod'
import { RecordId } from '@/types/common'

import { UomDto } from '../dto/uom-dto'

type UomMutation = Pick<UomDto, 'code'>

export const uomApi = {
  list: apiFactory({
    method: 'get',
    url: ENDPOINT.inventory.uom.list,
    schema: {
      result: apiOk(z.object({ uoms: UomDto.array() })),
    },
  }),
  detail: apiFactory({
    method: 'get',
    url: ENDPOINT.inventory.uom.detail,
    schema: {
      params: zh.ParamsId,
      result: apiOk(z.object({ uom: UomDto })),
    },
  }),
  create: apiFactory({
    method: 'post',
    url: ENDPOINT.inventory.uom.create,
    schema: {
      body: z.custom<UomMutation>(),
    },
  }),
  update: apiFactory({
    method: 'put',
    url: ENDPOINT.inventory.uom.update,
    schema: {
      body: z.custom<RecordId & UomMutation>(),
    },
  }),
}
